export default {
  setDialogState: function ({ commit }, { state }) {
    commit("SET_DIALOG", state);
  },
  setDialogData: function ({ commit }, { item }) {
    commit("SET_DIALOG_DATA", item);
  },
};
